import { BaseIcon } from '../BaseIcon';
import type { BaseIconProps } from '../BaseIcon';
import styles from './styles.scss';
import { joinClassNames } from '../../../../utils';

type PriorityCriticalIconProps = Omit<BaseIconProps, 'children'>;

export const PriorityCriticalIcon = ({ className, ...props }: PriorityCriticalIconProps) => (
  <BaseIcon
    hasLegacyStrokeStyles={false}
    width="17"
    height="17"
    viewBox="0 0 17 17"
    className={joinClassNames(styles.priorityCriticalIcon, className)}
    {...props}
  >
    <path d="M8.5 0.788086C4.1 0.788086 0.5 4.38809 0.5 8.78809C0.5 13.1881 4.1 16.7881 8.5 16.7881C12.9 16.7881 16.5 13.1881 16.5 8.78809C16.5 4.38809 12.9 0.788086 8.5 0.788086Z" />
    <path d="M9.5 3.78809H7.5V10.7881H9.5V3.78809Z" />
    <path d="M9.5 12.7881C9.5 13.3404 9.05228 13.7881 8.5 13.7881C7.94772 13.7881 7.5 13.3404 7.5 12.7881C7.5 12.2358 7.94772 11.7881 8.5 11.7881C9.05228 11.7881 9.5 12.2358 9.5 12.7881Z" />
  </BaseIcon>
);

PriorityCriticalIcon.displayName = 'PriorityCriticalIcon';
